export var TaskTypes;
(function (TaskTypes) {
    TaskTypes["WHITELIST"] = "WHITELIST";
    TaskTypes["BLOCKPLACEMENTS"] = "BLOCKPLACEMENTS";
    TaskTypes["BID_ADJUSTMENT"] = "BIDADJUSTMENTS";
    TaskTypes["BUDGET_AUTOMATION"] = "BUDGET_AUTOMATION";
    TaskTypes["BLOCK_PLACEMENTS"] = "BLOCK_PLACEMENTS";
    TaskTypes["PAUSE_PLACEMENTS"] = "PAUSE_PLACEMENTS";
    TaskTypes["PAUSE_ADS"] = "PAUSE_ADS";
})(TaskTypes || (TaskTypes = {}));
export var CronTypes;
(function (CronTypes) {
    CronTypes["Every 10 Minutes"] = "0/10 * * * *";
    CronTypes["Every 20 Minutes"] = "0/20 * * * *";
    CronTypes["Every 30 Minutes"] = "0/30 * * * *";
    CronTypes["Every 1 Hour"] = "0 0/1 * * *";
    CronTypes["Every 2 Hour"] = "0 0/2 * * *";
    CronTypes["Every 3 Hour"] = "0 0/3 * * *";
    CronTypes["Every 6 Hour"] = "0 0/6 * * *";
    CronTypes["Every 12 Hour"] = "59 */11 * * *";
    CronTypes["Daily ( At 12:00 PM UTC )"] = "0 0 * * *";
    CronTypes["Weekly ( At 12:00 PM UTC on Saturday )"] = "0 0 * * 0";
})(CronTypes || (CronTypes = {}));
export var TaskBehaviours;
(function (TaskBehaviours) {
    TaskBehaviours["notifyOnly"] = "notifyOnly";
    TaskBehaviours["notifyAndRun"] = "notifyAndRun";
    TaskBehaviours["run"] = "run";
})(TaskBehaviours || (TaskBehaviours = {}));
//# sourceMappingURL=enums.js.map